const currencies = {
  EUR: "€",
  USD: "$",
};

export default currencies;
